import { autoSyncBookingWithCalendar } from '../../src/lib/calendarSyncHelper'
import { $RootStore } from '../../src/stores/RootStore'

export function isExternalBooking(booking: Booking | SimpleExternalBooking): booking is SimpleExternalBooking {
  return booking.type === 'external'
}

export type SimpleExternalBooking = Omit<ExternalBooking, 'businessName'>
export type SimpleBooking = Omit<Booking, 'requestedProfessionals' | 'user'>

export interface SyncParams {
  booking: SimpleExternalBooking | SimpleBooking
  store: $RootStore
  showDropdown?: boolean
}

export const autoSyncBookingWithCalendar_shared = async (params: SyncParams) => {
  return autoSyncBookingWithCalendar(params)
}